import { render, staticRenderFns } from "./InutilizarNota.vue?vue&type=template&id=12b76eba&scoped=true"
import script from "./InutilizarNota.vue?vue&type=script&lang=js"
export * from "./InutilizarNota.vue?vue&type=script&lang=js"
import style0 from "./InutilizarNota.vue?vue&type=style&index=0&id=12b76eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b76eba",
  null
  
)

export default component.exports